import { render, staticRenderFns } from "./DateFormatter.vue?vue&type=template&id=2d6f69fc&"
import script from "./DateFormatter.vue?vue&type=script&lang=js&"
export * from "./DateFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6f69fc')) {
      api.createRecord('2d6f69fc', component.options)
    } else {
      api.reload('2d6f69fc', component.options)
    }
    module.hot.accept("./DateFormatter.vue?vue&type=template&id=2d6f69fc&", function () {
      api.rerender('2d6f69fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ol8N4oJmbtnX/JS/DateFormatter.vue"
export default component.exports